import Navbar from '../components/Navbar/Navbar';
import Footer from '../components/Footer/Footer';
import FormContacto from "../components/FormContacto/FormContacto";
import Head from 'next/head';

export default function Contacto() {
    const msg = <p>
        Nos gusta estar en comunicación con <span className={`fw-bold`}>personas y marcas geniales :D</span> <br /><br />
        Explícanos lo que necesitas
    </p>

    return (
        <>
            <Head>
                <title>Contacto | Where is my brand?</title>
                <meta name="description" content="WIMB: Agencia tradicional con ADN Digital" />
                <link rel="icon" href="/favicon.png" />
            </Head>
            <Navbar />
            <div className="mt-5">
                <FormContacto decorated={true} withPhoto={true} message={msg} referencia="contacto" />
            </div>
            <div className='d-none d-md-block' style={{ height: "12.5rem" }}></div>
            <Footer />
        </>
    )
}